module.exports = __webpack_public_path__ + "img/avatar0.80dde3b7.png";